import { useState, useEffect } from "react";
import { FaPhone, FaEnvelope } from 'react-icons/fa';
import Footer from "./component/Footer";
import AccountSidebar from "./component/AccountSidebar";

const ContactUs = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [mobileView, setMobileView] = useState("menu");

    const storedData = localStorage.getItem("userData");
    const userData = storedData ? JSON.parse(storedData) : {};
    const email = userData?.email || "example@gmail.com";
    const phone = userData?.phone || "1234567890";

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'auto' });
        const fn = () => setIsVisible(window.pageYOffset > 300);
        window.addEventListener('scroll', fn);
        return () => window.removeEventListener('scroll', fn);
    }, []);

    // ✅ Single-click mobile fix
    useEffect(() => {
        if (sessionStorage.getItem("mob_nav_direct") === "true") {
            sessionStorage.removeItem("mob_nav_direct");
            setMobileView("content");
        }
    }, []);

    const ContactContent = () => (
        <div className="user-info-card">
            <div>
                <p className="user-info-title">Contact Details</p>
                <p className="user-info-subtitle">Your registered contact information</p>
            </div>
            {email && (
                <div className="user-info-row">
                    <div className="user-info-icon"><FaEnvelope size={15} /></div>
                    <div className="user-info-text">
                        <span>Email Address</span>
                        <span>{email}</span>
                    </div>
                </div>
            )}
            {phone && (
                <div className="user-info-row">
                    <div className="user-info-icon"><FaPhone size={15} /></div>
                    <div className="user-info-text">
                        <span>Phone Number</span>
                        <span>{phone}</span>
                    </div>
                </div>
            )}
        </div>
    );

    return (
        <>
            <style>{`
                .dashboard-wrapper { 
                    display: flex; 
                    min-height: 80vh; 
                    padding: 20px; 
                    gap: 20px; 
                }
                .dashboard-content { 
                    flex: 1; 
                    min-width: 0; 
                    padding: 10px; 
                }

                /* Mobile Sidebar */
                .acct-mobile-only-wrapper { display: none; }

                /* Mobile Content Panel */
                .wl-mob-header {
                    display: flex; align-items: center; justify-content: space-between;
                    padding: 13px 16px; background: #fff; border-bottom: 1px solid #f0f0f0;
                    position: sticky; top: 0; z-index: 10;
                }
                .wl-mob-back-btn {
                    width: 36px; height: 36px; border: none; background: none;
                    font-size: 28px; color: #333; cursor: pointer;
                }
                .wl-mob-title { 
                    font-size: 16px; font-weight: 700; color: #111; margin: 0; 
                }
                .wl-mob-body { 
                    padding: 16px; background: #fff; min-height: auto; 
                }

                /* Content Styling */
                .user-info-card { 
                    background: #fff; 
                    border-radius: 10px; 
                    box-shadow: 0 2px 10px rgba(0,0,0,0.07); 
                    border: 1px solid #f0f0f0; 
                    padding: 28px 24px; 
                    display: flex; 
                    flex-direction: column; 
                    gap: 16px; 
                }
                .user-info-title { 
                    font-size: 17px; font-weight: 700; color: #1a1a1a; margin: 0 0 4px; 
                }
                .user-info-subtitle { 
                    font-size: 13px; color: #888; margin: 0; 
                }
                .user-info-row { 
                    display: flex; align-items: center; gap: 14px; 
                    background: #fff8e7; border: 1.5px solid #f0d88a; 
                    border-radius: 9px; padding: 14px 16px; 
                }
                .user-info-icon { 
                    width: 38px; height: 38px; background: #fff3cc; 
                    border-radius: 50%; display: flex; align-items: center; 
                    justify-content: center; color: #c9a227; flex-shrink: 0; 
                }
                .user-info-text { 
                    display: flex; flex-direction: column; gap: 2px; 
                }
                .user-info-text span:first-child { 
                    font-size: 11px; color: #999; font-weight: 700; 
                    text-transform: uppercase; letter-spacing: 0.4px; 
                }
                .user-info-text span:last-child { 
                    font-size: 15px; color: #222; font-weight: 500; 
                }

                /* ==================== VISIBILITY FIX ==================== */
                .acct-mobile-only-wrapper { display: none; }
                .dashboard-wrapper { display: flex; }

                @media (max-width: 768px) {
                    .acct-mobile-only-wrapper { display: block; }
                    .dashboard-wrapper { display: none !important; }
                    .user-info-card { padding: 20px 16px; }
                }

                @media (min-width: 769px) {
                    .wl-mob-content-panel { display: none !important; }
                    .dashboard-wrapper { display: flex !important; }
                }
            `}</style>

            <main className="main__content_wrapper">

                {/* ==================== MOBILE ==================== */}
                <div className="acct-mobile-only-wrapper">
                    <AccountSidebar
                        mobileView={mobileView}
                        setMobileView={setMobileView}
                        activeMobilePath="/user-contact"
                        contentViewName="content"
                    />
                </div>

                {/* Mobile Content */}
                <div 
                    className="wl-mob-content-panel"
                    style={{ display: mobileView === "content" ? "block" : "none" }}
                >
                    <div className="wl-mob-header">
                        <button className="wl-mob-back-btn" onClick={() => setMobileView("menu")}>‹</button>
                        <h2 className="wl-mob-title">Contact Us</h2>
                        <div style={{ width: 36 }} />
                    </div>
                    <div className="wl-mob-body">
                        <ContactContent />
                    </div>
                </div>

                {/* ==================== DESKTOP ==================== */}
                <div className="container-fluid">
                    <div className="dashboard-wrapper">
                        <AccountSidebar
                            mobileView={mobileView}
                            setMobileView={setMobileView}
                            activeMobilePath="/user-contact"
                            contentViewName="content"
                        />
                        <div className="dashboard-content">
                            <ContactContent />
                        </div>
                    </div>
                </div>

            </main>

            <Footer />

            {/* Scroll to Top Button */}
            <button 
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                style={{
                    position: 'fixed', bottom: '30px', right: '30px',
                    width: '46px', height: '46px', borderRadius: '50%',
                    backgroundColor: '#ceb256', color: '#fff', border: 'none',
                    zIndex: 1000, cursor: 'pointer',
                    display: isVisible ? 'flex' : 'none',
                    alignItems: 'center', justifyContent: 'center',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.2)'
                }}
            >
                ↑
            </button>
        </>
    );
};

export default ContactUs;